module.exports = __webpack_public_path__ + "static/media/icon-piece3-3.77c8be73.png";